const getBucketGatewayBaseUrl = (): string | undefined =>
  (window.env?.hosts?.bucketGateway as string | undefined) ||
  process.env.REACT_APP_BUCKET_GATEWAY_URL;

export const fetchPdfBlobFromBucket = async (
  pdfSlug: string,
  keycloak: Keycloak.KeycloakInstance,
): Promise<Blob> => {
  const baseUrl = getBucketGatewayBaseUrl();
  if (!baseUrl) {
    throw new Error('Bucket gateway URL is not configured');
  }

  const tokenExpiryTime = parseInt(
    (process.env as Record<string, string>).REACT_APP_TOKEN_VALIDITY_IN_SECONDS,
    10,
  );

  await keycloak.updateToken(tokenExpiryTime);

  const headers = new Headers();
  headers.set('Authorization', `Bearer ${keycloak.token}`);

  const presignedUrlResponse = await fetch(`${baseUrl}/${pdfSlug}`, {
    headers,
    credentials: 'same-origin',
  });

  if (!presignedUrlResponse.ok) {
    throw new Error(
      `Bucket gateway request failed (${presignedUrlResponse.status})`,
    );
  }

  const presignedUrl = (await presignedUrlResponse.text()).trim();
  if (!presignedUrl) {
    throw new Error('Bucket gateway returned an empty presigned URL');
  }

  const pdfResponse = await fetch(presignedUrl, {
    credentials: 'same-origin',
  });

  if (!pdfResponse.ok) {
    throw new Error(`PDF fetch failed (${pdfResponse.status})`);
  }

  return pdfResponse.blob();
};
